export default "__VITE_ASSET__DXI00hIH__"